module.exports = __webpack_public_path__ + "img/festival_halloween.906b4a17.png";